import { PDF_COLORS, PDF_FONTS, PDF_LAYOUT } from "../../utils/pdfStyles";
import { asText, ensureSpace } from "../../utils/pdfHelpers";

export const drawFirmas = (doc, { plan, startY }) => {
  const x = PDF_LAYOUT.marginX;
  const w = PDF_LAYOUT.contentWidth;
  const signatureHeight = 65;

  let y = ensureSpace(doc, startY, signatureHeight + 15);
  y += 14; // clearance

  const boxW = (w - 30) / 2;
  const lineY = y + 26;

  // 1. Gestante / Acompañante
  doc.setDrawColor(...PDF_COLORS.border);
  doc.setLineWidth(1);
  doc.line(x + 10, lineY, x + boxW - 10, lineY);

  doc.setFont(PDF_FONTS.family, "bold");
  doc.setFontSize(PDF_FONTS.sizes.label);
  doc.setTextColor(...PDF_COLORS.textDark);
  doc.text("FIRMA DE LA GESTANTE / ACOMPAÑANTE", x + boxW / 2, lineY + 11, { align: "center" });

  doc.setFont(PDF_FONTS.family, "normal");
  doc.setFontSize(PDF_FONTS.sizes.small);
  doc.setTextColor(...PDF_COLORS.textMuted);
  const nombreGestante = asText(plan?.paciente_nombre || plan?.acompanante, "Gestante");
  const docGestante = plan?.paciente_identificacion || plan?.Unic_ID ? `Doc: ${plan?.paciente_identificacion || plan?.Unic_ID}` : "";
  doc.text(nombreGestante, x + boxW / 2, lineY + 19, { align: "center" });
  if (docGestante) {
    doc.text(docGestante, x + boxW / 2, lineY + 27, { align: "center" });
  }

  // 2. Profesional de Salud
  const rightX = x + boxW + 30;
  doc.setDrawColor(...PDF_COLORS.border);
  doc.setLineWidth(1);
  doc.line(rightX + 10, lineY, rightX + boxW - 10, lineY);

  doc.setFont(PDF_FONTS.family, "bold");
  doc.setFontSize(PDF_FONTS.sizes.label);
  doc.setTextColor(...PDF_COLORS.textDark);
  doc.text("FIRMA DEL PROFESIONAL DE LA SALUD", rightX + boxW / 2, lineY + 11, { align: "center" });

  doc.setFont(PDF_FONTS.family, "normal");
  doc.setFontSize(PDF_FONTS.sizes.small);
  doc.setTextColor(...PDF_COLORS.textMuted);
  const nombreProf = asText(plan?.profesional_nombre, "Médico / Profesional Tratante");
  const regProf = plan?.profesional_identificacion
    ? `Registro / T.P.: ${plan.profesional_identificacion}`
    : "Registro Médico / T.P. No. __________________";
  doc.text(nombreProf, rightX + boxW / 2, lineY + 19, { align: "center" });
  doc.text(regProf, rightX + boxW / 2, lineY + 27, { align: "center" });

  return lineY + 32;
};

export const applyDocumentFooters = (doc, { legalText = "Ley 2244 de 2022 (Parto Digno y Respetado) | Resolución 3280 de 2018 (Ruta Materno-Perinatal)", folio = null, plan = null } = {}) => {
  const totalPages = doc.getNumberOfPages();
  const x = PDF_LAYOUT.marginX;
  const w = PDF_LAYOUT.contentWidth;
  const footerY = PDF_LAYOUT.pageHeight - 18;

  const pacienteNombre = asText(plan?.paciente_nombre, "");
  const docIdentidad = plan?.paciente_tipo_id && plan?.paciente_identificacion
    ? `${plan.paciente_tipo_id} ${plan.paciente_identificacion}`
    : asText(plan?.Unic_ID, "");

  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);

    // Encabezado en páginas 2 en adelante para identificar el documento
    if (i > 1) {
      doc.setFont(PDF_FONTS.family, "normal");
      doc.setFontSize(PDF_FONTS.sizes.small);
      doc.setTextColor(...PDF_COLORS.textMuted);
      const folText = folio ? ` | Folio: #${folio}` : "";
      const pacText = pacienteNombre ? ` | Paciente: ${pacienteNombre} (${docIdentidad})` : "";
      doc.text(`PLAN DE PARTO${folText}${pacText}`, x, 24);
      doc.text(`Pág. ${i}`, x + w, 24, { align: "right" });

      doc.setDrawColor(...PDF_COLORS.borderLight);
      doc.setLineWidth(0.5);
      doc.line(x, 28, x + w, 28);
    }

    // Línea divisoria de pie de página
    doc.setDrawColor(...PDF_COLORS.borderLight);
    doc.setLineWidth(0.5);
    doc.line(x, footerY - 8, x + w, footerY - 8);

    // Texto legal a la izquierda
    doc.setFont(PDF_FONTS.family, "normal");
    doc.setFontSize(PDF_FONTS.sizes.footer);
    doc.setTextColor(...PDF_COLORS.textMuted);
    doc.text(legalText, x, footerY);

    // Paginación a la derecha
    const pageStr = `Página ${i} de ${totalPages}`;
    doc.text(pageStr, x + w, footerY, { align: "right" });
  }
};
